/* globals $:false, Bloodhound:false */

import ExternalInstanceM from '../model/recordm.model.entity.externalinstance.js';

import tmpl_entry from '../templates/search-unified-entity.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

// Component capable of handling ExtRef fields.
//
// args:
// * `productKey`: the productKey defined in the web.integration.properties file
// * `searchTemplate`: the template used to build search URIs
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: the Callback invoked when a user selects a result
// * `header`: The header of the suggestions box
// * `maxRows`: Then number of results
//
const ExtRef = function(core, productKey, searchTemplate, confs) {

    var _loadingKey = core.getLoadingKey();

    var _$html, _$input;
    let _previousStyle = "";

    var _searchTemplate = searchTemplate,
        _typeaheadQueryEngine,
        _selectedInstanceLabel = '',
        _selectedIndexedInstance,
        _valueWhileStillLoading;

    var _baseUri = core.getBaseAppUrl(productKey);

    var _confs = {
        id: core.locallyUniqueId(),
        fieldDefinition: {name: ""},
        readonly: false,
        valueChanged: undefined,

        header: core.translateString("recordm.search", "search.select-record"),
        maxRows: 5
    };

    utils.extend(_confs, confs, true);

    var _loadReference = function(instanceURI) {
        if (instanceURI) {
            core.showLoading(_loadingKey, 'get reference instance');

            ExternalInstanceM.get(core, instanceURI, {
                instanceURI: _baseUri + instanceURI,
                accepts: 'application/vnd.recordm-external+json',
                forceReload: true,
                success: function(indexedInstanceM) {
                   // we use the smallest timeout so that fields that
                   // listen for changes are all already listening
                   setTimeout(() => {
                      _onSelect(undefined, {entity: indexedInstanceM});

                      core.hideLoading(_loadingKey, 'get reference instance success');
                   }, 10);
                },
                error: function() {
                    core.hideLoading(_loadingKey, 'get reference instance error');
                }
            });
        }
    };

    var _updateSearchTemplate = function(newSearchTemplate){
        _searchTemplate = newSearchTemplate || _searchTemplate;
        _typeaheadQueryEngine.remote.url = _getSearchUrl();
    };

    var _getSearchUrl = function(){
        return _baseUri + _searchTemplate;
    };

    var _onSelect = function(e, record) {
        var instanceLabel;

        _valueWhileStillLoading = undefined;
        _selectedIndexedInstance = record.entity;

        if (_$input) {

            instanceLabel = _selectedIndexedInstance.getInstanceLabel();
            if (!_confs.readonly) {
                //TODO jbarata: hack to workaround the https://github.com/twitter/typeahead.js/issues/646
                if(_$input.data('ttTypeahead')){ //if the presenter was destroyed, there's no longer a value for the attribute
                   var typeaheadInput = _$input.data('ttTypeahead').input;
                   typeaheadInput.setQuery(instanceLabel);
                   typeaheadInput.resetInputValue();
                }
                // /*qd o issue for corrigido deve ficar esta linha em vez das 3 acima*/ _$input.typeahead('val', instanceLabel);
                //fim do hack

                _selectedInstanceLabel = instanceLabel;

            } else {
                _$input.val(instanceLabel);
            }
        }

        if (_confs.valueChanged) {
            _confs.valueChanged(record);
        }
    };

    var _onClose = function() {
        // The query changed so let's clean the selected instance
        _selectedInstanceLabel = _selectedInstanceLabel || '';
        if (_selectedInstanceLabel.trim() !== _$input.val().trim()) {
            _selectedIndexedInstance = undefined;
            _$input.typeahead('val', '');

            // let's notify that the selected value changed
            if (_confs.valueChanged) {
                _confs.valueChanged(undefined);
            }
        }
    };

    var _parseResponse = function(response) {
        // update the response with the new response
        return response.map(function(hit) {
            var model = new ExternalInstanceM(core, hit);

            return  {
                entity: model,
                title: model.getInstanceLabel(),
                details: model.getInstanceDescription()
            }
        });
    };

    var _render = function() {
        var $typeaheadBtn;

        _$html = $([
            '<div class="tt-wrapper input-append">',
            `<input id="f${_confs.id}" class="js-autocomplete autocomplete field-value cob-field-value" type="text" value="${_selectedInstanceLabel}"  placeholder="${_confs.fieldDefinition.name}">`,
            '<button class="btn js-typeahead-btn" type="button" tabindex="-1"><i class="icon-search"></button>',
            '</div>'
        ].join(''));

        _$input = _$html.find(".js-autocomplete");

        if (!_confs.readonly) {
            _typeaheadQueryEngine = new Bloodhound({
                datumTokenizer: function(d) { return Bloodhound.tokenizers.whitespace(d.title); },
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                limit: _confs.maxRows,
                remote: {
                    url: _getSearchUrl(),
                    filter: _parseResponse,
                    // The plugin only replaces the first "%QUERY" so we do not use that notation.
                    // I had to implement the replace function to replace all "{{this}}" by the input value
                    replace: function(remoteUrl, query) {
                        return remoteUrl.replace(/{{this}}/g, encodeURIComponent(query));
                    },
                    // we need this to make authenticated CORS requests
                    ajax: {
                        //this is a little confusing, but I believe that jQuery uses the value of dataType
                        //as the key to the accepts object. So we need both. The dataType to say that we are
                        // expecting json, and the accepts to specify the "Accepts" header value for json.
                        dataType: 'json',
                        accepts: {
                            json: 'application/vnd.recordm-external+json'
                        },
                        xhrFields: {
                            withCredentials: true
                        }
                    }
                }
            });

            _typeaheadQueryEngine.initialize();

            _$input.typeahead(null, {
                name: productKey,
                displayKey: 'title',
                source: _typeaheadQueryEngine.ttAdapter(),
                templates: {
                    header: '<p class="tt-header">' + _confs.header + '</p>',
                    suggestion: function(data) {
                        return tmpl_entry(data)
                    }
                }
            });

            _$input.on('typeahead:selected', _onSelect);
            _$input.on('typeahead:closed', _onClose);

            // overwriting typeahead transparent background
            _$input.css("background-color", "#fff");

            $typeaheadBtn = _$html.find(".js-typeahead-btn");
            $typeaheadBtn.click(function() {
                var currentVal = _$input.val();
                //we need to append * so that search is done always
                _$input.typeahead('val', currentVal + "*");
                _$input.typeahead('open');
                _$input.typeahead('val', currentVal); //hide the * right after the search
                _$input.focus();
            });

        } else {
            _$input.attr("readonly", "readonly").attr("tabindex", -1);
        }

        if (_selectedIndexedInstance) {
            _onSelect(undefined, {entity: _selectedIndexedInstance});
        }

        return _$html;
    };

    var _clearError = function() {
        _$input.removeClass("error");
    };

    var _showError = function() {
        _$input.addClass("error");
    };

    var _destroy = function() {
        if (!_confs.readonly) {
            _$input.off('typeahead:selected', _onSelect);
            _$input.off('typeahead:closed', _onClose);

            _$input.typeahead('destroy');
        }

        if (_selectedIndexedInstance) {
            _selectedIndexedInstance.release();
        }
    };

    const _removeValue = function (){
        _valueWhileStillLoading = undefined;
        _selectedIndexedInstance = undefined;

        if(_$input){
            _$input.val('');

            // let's notify that the selected value changed
            if (_confs.valueChanged) {
                _confs.valueChanged(undefined);
            }
        }
    }

    return {
        render: _render,
        destroy: _destroy,

        clearError: _clearError,
        showError: _showError,

        setValue: function(value, label) {
            if(!value){
                _removeValue();
                return;
            }

            // we keep this until the reference is loaded, so that getValue() doesn't return indefined
            _valueWhileStillLoading = value;
            _selectedInstanceLabel = label || '';

            // creio que isto só acontece se fizermos "paste" via url
            if (_$input) _$input.val(value);
            _loadReference(value);
        },
        getValue: function() {
            var value = _valueWhileStillLoading;
            if (_selectedIndexedInstance) {
                value = _selectedIndexedInstance.data._links.self;
                if (value === undefined) {
                    throw new Error("ERROR: could not set value for extRef field. " +
                                    "Check that the external entity has the _links.self attribute ");
                }
            }

            return value;
        },

        disableSelf: function(){
            _previousStyle = _$input.attr("style");
            _$input.prop("readonly", true).attr("tabindex", -1).removeAttr("style");
            _$html.find('.js-typeahead-btn').prop("disabled", true).attr("tabindex", -1)
        },
        enableSelf: function(){
            _$input.removeProp("readonly").removeAttr("tabindex").attr("style", _previousStyle);
            _$html.find('.js-typeahead-btn').removeProp("disabled").removeAttr("tabindex");
        },
        isEnabled: function () {
            return !_$input.prop('readonly');
        },

        // specific functions
        getModel: function() {
            return _selectedIndexedInstance;
        },
        setUrlTemplate: _updateSearchTemplate
    }
};

export default ExtRef;
